import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomeRedirect from "routes/HomeRedirect";

import Login from "pages/Login";

import DashboardLayout from "layouts/DashboardLayout";

import ProtectedRoute from "routes/ProtectedRoute";
import GuestRoute from "routes/GuestRoute";
import { appConfig, ROUTES } from "config";
import { flattenMenuRoutes } from "utils/permissions/flattenMenuRoutes";
import menu from "config/menu";
import extraRoutes from "routes/nonMenuRoutes";
import ForgotPassword from "pages/ForgotPassword";
import ResetPassword from "pages/ResetPassword";

// const dashboardChildren = flattenMenuRoutes(menu);
const dashboardChildren = [...flattenMenuRoutes(menu), ...extraRoutes];

const router = createBrowserRouter(
    [
        {
            path: ROUTES.ROOT,
            element: <HomeRedirect />
        },
        {
            path: ROUTES.LOGIN,
            element: (
                <GuestRoute>
                    <Login />
                </GuestRoute>
            )
        },
        {
            path: ROUTES.FORGOT_PASSWORD,
            element: (
                <GuestRoute>
                    <ForgotPassword />
                </GuestRoute>
            )
        },
        {
            path: ROUTES.RESET_PASSWORD,
            element: (
                <GuestRoute>
                    <ResetPassword />
                </GuestRoute>
            )
        },
        {
            element: (
                <ProtectedRoute>
                    <DashboardLayout />
                </ProtectedRoute>
            ),
            children: dashboardChildren
        },
        {
            path: "*",
            element: <HomeRedirect />
        }
    ],
    {
        basename: appConfig.basename
    }
);

export default function AppRoutes() {
    return <RouterProvider router={router} />;
}
